import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';
const HappySchoolRoutes = [
    {
        label: getCorrespondLabel('104'),
        key: '104',
        path: '104',
        show: true,
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        label: getCorrespondLabel('101'),
        key: '101',
        show: true,
        path: '101',
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        label: getCorrespondLabel('103'),
        key: '103',
        show: true,
        path: '103',
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        label: getCorrespondLabel('109'),
        key: '109',
        path: '109',
        show: true,
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        label: getCorrespondLabel('201'),
        key: '201',
        path: '201',
        show: true,
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        label: getCorrespondLabel('107'),
        key: '107',
        path: '107',
        show: true,
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        show: true,
        label: getCorrespondLabel('108'),
        key: '108',
        path: '108',
        element: lazy(() => import('@/page/HappySchool/Project/Project'))
    },
    {
        show: true,
        label: '我的' + getCorrespondLabel('110'),
        key: 'my-questionnaire',
        path: 'my-questionnaire',
        element: lazy(() => import('@/page/MyQuestionnaire'))
    },
    {
        label: '我的帖子',
        key: 'myCommunty',
        show: true,
        path: 'myCommunty',
        element: lazy(() => import('@/page/myCommunty/index'))
    },
    {
        show: true,
        label: '我的画像',
        key: 'student-portrait',
        path: 'student-portrait',
        element: lazy(() => import('@/page/StudentPortrait/index2')) //切换index
    },
    {
        show: true,
        label: '我的业绩',
        key: 'teacher-performance',
        path: 'teacher-performance',
        element: lazy(() => import('@/page/TeacherPerformance'))
    }
];
export default HappySchoolRoutes;
